module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('h3', {
    staticClass: "logo"
  }, [_vm._v("\n    " + _vm._s(_vm.config.name) + "\n    "), _c('small', [_vm._v(_vm._s(_vm.config.version))])]), _vm._v(" "), _c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.config.links), function(val, key) {
    return _c('li', [_c('a', {
      attrs: {
        "href": val
      }
    }, [_vm._v(_vm._s(key))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25735e4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/Header.vue
// module id = 625
// module chunks = 0